
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { IconDirective } from 'shared/ui-common';

import { GuidelineSyncService } from '../../../../../../libs/shared/util-common/src/lib/services/guideline-sync.service';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-guideline-sync-popover',
  templateUrl: './guideline-sync-popover.component.html',
  styleUrls: ['./guideline-sync-popover.component.scss'],
  imports: [MatIcon, IconDirective, TranslocoPipe],
})
export class GuidelineSyncPopoverComponent {
  private guidelineSyncService = inject(GuidelineSyncService);

  protected status = this.guidelineSyncService.syncStatus;
  protected progress = this.guidelineSyncService.progress;
}
